import { Outlet } from "react-router";

export function ResourcesLayout() {
  return <Outlet />;
}
